// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"43eeb44d","68":"0af9f47a","95":"8ac1c1fe","134":"afccfcf5","313":"0815c4c9","404":"0b5b5e57","483":"ba76f6e3","825":"566bf4e0","950":"0a1c9916","969":"925a8173"}[chunkId] + ".chunk.js";
};